module.exports = {
    ICONS_CATEGORIES: {
        1: 'icon-cajero',
        2: 'icon-casa-hogar',
        3: 'icon-comercio-tiendas',
        4: 'icon-eduacion-salud-belleza',
        5: 'icon-ingresos',
        6: 'icon-inversiones-ahorros',
        7: 'icon-mov-excluidos',
        8: 'icon-viajes',
        9: 'icon-otros-gastos',
        10: 'icon-restaurantes',
        11: 'icon-banco-ong-seguros',
        12: 'icon-transferir',
        13: 'icon-transporte-automacion',
        14: 'icon-gastos-profesionales',
    },
    ICONS_CATEGORIES_URL: 'https://www.openbank.es/assets/static/images/categories/icons/'
}
